import * as React from 'react'

import {Page} from '@frontrow/console/src/components/ui/page'
import EditSchoolFormContainer from '@frontrow/console/src/components/pages/edit-school-page/edit-school-form'
import {
  type DetailedSchoolT,
  type BasicSchoolWithRenaissanceClientT
} from '@frontrow/console/src/models/school'
import {CrmManagedAlert} from '@frontrow/console/src/components/common/crm-managed-alert'
import SchoolActionsSection from '@frontrow/console/src/components/common/school-actions-section'

type Props = {
  school: DetailedSchoolT
  onSubmit: (args: {
    updatedSchool: BasicSchoolWithRenaissanceClientT
    shouldAddFakeDistrict: boolean
    shouldDeleteCleverAndClasslinkAssociations: boolean
  }) => void
  schoolsUrl: string
}

export default function EditSchool(props: Props): React.ReactElement {
  const {school, onSubmit, schoolsUrl} = props
  const {active, crmId, renaissanceSchoolClient} = school
  const mClientId = renaissanceSchoolClient?.clientId
  const title = `Update ${school.name}`

  return (
    // The form is a two-column grid; past ~1120px the columns get wider than a
    // UUID needs and the labels drift away from their values.
    <div className="max-w-[1120px]">
      <Page
        title={title}
        breadcrumbsAttrs={{
          path: [{url: schoolsUrl, name: 'Schools'}],
          currentItemName: title
        }}
      >
        <CrmManagedAlert
          active={active}
          addClass="mb-4"
          crmId={crmId}
          crmManagedEntity={'school'}
          instructions="To update name and address information, make the changes in CRM."
        />

        <div className="mb-6">
          <SchoolActionsSection clientId={mClientId} schoolId={props.school.id} active={active} />
        </div>

        <EditSchoolFormContainer schoolToUpdate={school} onSubmit={onSubmit} />
      </Page>
    </div>
  )
}
